export default "__VITE_ASSET__BWyTkzcy__"